module.exports = "<!-- <div [class.se-pre-con]=\"isLoading\"></div> -->\n<div [class]=\"isLoading ? 'loader show' : 'loader none'\">\n  <div class=\"text-inner\">\n    <h1 class=\"loading\">Đang load ...</h1>\n    <div class=\"loader-inner\">\n      <div class=\"inner one\"></div>\n      <div class=\"inner two\"></div>\n      <div class=\"inner three\"></div>\n    </div>\n    <h4>hãy vui lòng đợi...</h4>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loading/loading.component.html
// module id = ./src/app/shared/loading/loading.component.html
// module chunks = main